export default {
    VITE_BACKEND_BASE_URL: import.meta.env.VITE_BACKEND_BASE_URL,
    VITE_ENV: import.meta.env.VITE_ENV,
    VITE_CACHE_BUSTER: import.meta.env.VITE_CACHE_BUSTER,
    VITE_SENTRY: import.meta.env.VITE_SENTRY,
    VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    VITE_SENTRY_SAMPLE_RATE: import.meta.env.VITE_SENTRY_SAMPLE_RATE,
    VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE: import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    VITE_REPLAYS_ON_ERROR_SAMPLE_RATE: import.meta.env.VITE_REPLAYS_ON_ERROR_SAMPLE_RATE,
    VITE_ENCRYPTED_KEY: import.meta.env.VITE_ENCRYPTED_KEY,
};
